"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.predictOptimisticState = exports.getNextAppOp = exports.getActionPlan = exports.updateAllProgress = exports.isLiveSupportedApp = exports.isOutOfMemoryState = exports.isIncompleteState = exports.getBlockSize = exports.distribute = exports.reducer = exports.initState = void 0;
var rxjs_1 = require("rxjs");
var flatMap_1 = __importDefault(require("lodash/flatMap"));
var semver_1 = __importDefault(require("semver"));
var devices_1 = require("@ledgerhq/devices");
var currencies_1 = require("../currencies");
var errors_1 = require("../errors");
var initState = function (_a, appsToRestore) {
    var deviceModelId = _a.deviceModelId, appsListNames = _a.appsListNames, installed = _a.installed, appByName = _a.appByName, listAppsResult = __rest(_a, ["deviceModelId", "appsListNames", "installed", "appByName"]);
    var state = __assign(__assign({}, listAppsResult), { installed: installed, appByName: appByName, apps: appsListNames.map(function (name) { return appByName[name]; }).filter(Boolean), deviceModel: (0, devices_1.getDeviceModel)(deviceModelId), recentlyInstalledApps: [], installQueue: [], uninstallQueue: [], updateAllQueue: [], currentProgressSubject: new rxjs_1.Subject(), currentError: null, currentAppOp: null });
    if (appsToRestore) {
        state = appsToRestore
            .filter(function (name) { return appByName[name] && !installed.some(function (a) { return a.name === name; }); })
            .map(function (name) {
            return ({
                type: "install",
                name: name
            });
        })
            .reduce(exports.reducer, state);
    }
    return state;
};
exports.initState = initState;
// ^TODO move this to legacyDependencies.js
// we should have dependency as part of the data!
var reorderInstallQueue = function (appByName, apps) {
    var list = [];
    apps.forEach(function (app) {
        if (list.includes(app))
            return;
        if (app in appByName) {
            var deps = appByName[app].dependencies;
            deps.forEach(function (dep) {
                if (apps.includes(dep) && !list.includes(dep)) {
                    list.push(dep);
                }
            });
        }
        list.push(app);
    });
    return list;
};
var reorderUninstallQueue = function (appByName, apps) {
    return reorderInstallQueue(appByName, apps.slice(0).reverse()).reverse();
};
var findDependents = function (appByName, name) {
    var all = [];
    for (var k in appByName) {
        var app = appByName[k];
        if (app.dependencies.includes(name)) {
            all.push(app.name);
        }
    }
    return all;
};
var reducer = function (state, action) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    switch (action.type) {
        case "onRunnerEvent": {
            // an app operation was correctly prefered. update state accordingly
            var event_1 = action.event;
            var appOp_1 = event_1.appOp;
            if (event_1.type === "runStart") {
                return __assign(__assign({}, state), { currentAppOp: appOp_1, currentProgressSubject: new rxjs_1.Subject() });
            }
            else if (event_1.type === "runSuccess") {
                if (state.currentProgressSubject) {
                    state.currentProgressSubject.complete();
                }
                var nextState = void 0;
                if (appOp_1.type === "install") {
                    var app = state.apps.find(function (a) { return a.name === appOp_1.name; });
                    nextState = __assign(__assign({}, state), { currentAppOp: null, currentProgressSubject: null, currentError: null, recentlyInstalledApps: state.recentlyInstalledApps.concat(appOp_1.name), 
                        // append the app to known installed apps
                        installed: state.installed
                            .filter(function (o) { return o.name !== appOp_1.name; })
                            .concat({
                            name: appOp_1.name,
                            updated: true,
                            hash: app ? app.hash : "",
                            blocks: app && app.bytes
                                ? Math.ceil(app.bytes / getBlockSize(state))
                                : 0,
                            version: app ? app.version : "",
                            availableVersion: app ? app.version : ""
                        }), 
                        // remove the install action
                        installQueue: state.installQueue.filter(function (name) { return appOp_1.name !== name; }) });
                }
                else {
                    nextState = __assign(__assign({}, state), { currentAppOp: null, currentProgressSubject: null, currentError: null, 
                        // remove apps to known installed apps
                        installed: state.installed.filter(function (i) { return appOp_1.name !== i.name; }), 
                        // remove the uninstall action
                        uninstallQueue: state.uninstallQueue.filter(function (name) { return appOp_1.name !== name; }) });
                }
                if (nextState.installQueue.length + nextState.uninstallQueue.length ===
                    0) {
                    nextState.updateAllQueue = [];
                }
                return nextState;
            }
            else if (event_1.type === "runError") {
                // TO BE CONTINUED LL-2138
                // to handle recovering from error. however we are not correctly using it at the moment.
                /*
                  const error = event.error;
                  if (error instanceof ManagerDeviceLockedError) {
                    return {
                      ...state,
                      currentError: {
                        appOp: appOp,
                        error: event.error
                      }
                    };
                  }
                  */
                if (state.currentProgressSubject) {
                    state.currentProgressSubject.complete();
                }
                // any other error stops everything
                return __assign(__assign({}, state), { uninstallQueue: [], installQueue: [], updateAllQueue: [], currentAppOp: null, currentProgressSubject: null, currentError: {
                        appOp: appOp_1,
                        error: event_1.error
                    } });
            }
            else if (event_1.type === "runProgress") {
                // we just emit on the subject
                if (state.currentProgressSubject) {
                    state.currentProgressSubject.next(event_1.progress);
                }
                return state; // identity state will not re-render the UI
            }
            return state;
        }
        case "recover":
            return __assign(__assign({}, state), { currentError: null });
        case "wipe":
            return __assign(__assign({}, state), { currentError: null, installQueue: [], uninstallQueue: reorderUninstallQueue(state.appByName, state.installed.map(function (_a) {
                    var name = _a.name;
                    return name;
                })) });
        case "updateAll": {
            var installList_1 = state.installQueue.slice(0);
            var uninstallList_1 = state.uninstallQueue.slice(0);
            state.installed
                .filter(function (_a) {
                var updated = _a.updated, name = _a.name;
                return !updated && state.appByName[name];
            })
                .forEach(function (app) {
                var dependents = state.installed
                    .filter(function (a) {
                    var depApp = state.appByName[a.name];
                    return depApp && depApp.dependencies.includes(app.name);
                })
                    .map(function (a) { return a.name; });
                uninstallList_1 = uninstallList_1.concat(__spreadArray([app.name], __read(dependents), false));
                installList_1 = installList_1.concat(__spreadArray([app.name], __read(dependents), false));
            });
            var installQueue = reorderInstallQueue(state.appByName, installList_1);
            var uninstallQueue = reorderUninstallQueue(state.appByName, uninstallList_1);
            /** since install queue === uninstall queue in this case we can map the update queue to either one */
            var updateAllQueue = installQueue;
            return __assign(__assign({}, state), { currentError: null, installQueue: installQueue, uninstallQueue: uninstallQueue, updateAllQueue: updateAllQueue });
        }
        case "install": {
            var name_1 = action.name;
            if (state.installQueue.includes(name_1)) {
                // already queued for install
                return state;
            }
            var existing = state.installed.find(function (app) { return app.name === name_1; });
            if (existing && existing.updated && state.installedAvailable) {
                // already installed and up to date
                return state;
            }
            var depApp = state.appByName[name_1];
            // No app found but fw update is available
            if (!depApp &&
                ((_c = (_b = (_a = state.firmware) === null || _a === void 0 ? void 0 : _a.updateAvailable) === null || _b === void 0 ? void 0 : _b.final) === null || _c === void 0 ? void 0 : _c.version) &&
                semver_1["default"].lt(state.deviceInfo.version, ((_f = (_e = (_d = state.firmware) === null || _d === void 0 ? void 0 : _d.updateAvailable) === null || _e === void 0 ? void 0 : _e.final) === null || _f === void 0 ? void 0 : _f.version) || "")) {
                throw new errors_1.LatestFirmwareVersionRequired("LatestFirmwareVersionRequired", {
                    current: state.deviceInfo.version,
                    latest: (_j = (_h = (_g = state.firmware) === null || _g === void 0 ? void 0 : _g.updateAvailable) === null || _h === void 0 ? void 0 : _h.final) === null || _j === void 0 ? void 0 : _j.version
                });
            }
            if (!depApp) {
                throw new errors_1.NoSuchAppOnProvider("", { appName: name_1 });
            }
            var deps_1 = depApp.dependencies;
            var dependentsOfDep_1 = (0, flatMap_1["default"])(deps_1, function (dep) {
                return findDependents(state.appByName, dep);
            });
            var depsInstalledOutdated = state.installed.filter(function (a) { return deps_1.includes(a.name) && !a.updated; });
            var installList = state.installQueue;
            // installing an app will remove if planned for uninstalling
            var uninstallList = state.uninstallQueue.filter(function (u) { return name_1 !== u && !deps_1.includes(u); });
            if (state.uninstallQueue.length !== uninstallList.length) {
                // app was asked for uninstall so it means we need to just cancel.
                // TODO cover this in tests...
            }
            else {
                // if app is already installed but outdated, we'll need to update related deps
                if ((existing && !existing.updated) || depsInstalledOutdated.length) {
                    // if app has installed direct dependent apps, we'll need to update them too
                    var directDependents_1 = findDependents(state.appByName, name_1).filter(function (d) { return state.installed.some(function (a) { return a.name === d; }); });
                    var outdated = state.installed
                        .filter(function (a) {
                        return !a.updated &&
                            __spreadArray(__spreadArray(__spreadArray([
                                name_1
                            ], __read(deps_1), false), __read(directDependents_1), false), __read(dependentsOfDep_1), false).includes(a.name);
                    })
                        .map(function (a) { return a.name; });
                    uninstallList = uninstallList.concat(outdated);
                    installList = installList.concat(outdated);
                }
                installList = installList.concat(__spreadArray(__spreadArray([], __read(deps_1.filter(function (d) { return !state.installed.some(function (a) { return a.name === d; }); })), false), [
                    name_1,
                ], false));
            }
            var installQueue = reorderInstallQueue(state.appByName, installList);
            var uninstallQueue = reorderUninstallQueue(state.appByName, uninstallList);
            return __assign(__assign({}, state), { currentError: null, installQueue: installQueue, uninstallQueue: uninstallQueue });
        }
        case "uninstall": {
            var name_2 = action.name;
            if (state.uninstallQueue.includes(name_2)) {
                // already queued
                return state;
            }
            // uninstalling an app will remove from installQueue as well as direct deps
            var installQueue = state.installQueue.filter(function (u) { return name_2 !== u; });
            var uninstallQueue = state.uninstallQueue;
            if (state.installed.some(function (a) { return a.name === name_2 || a.name === ""; }) ||
                action.force || // if installed unavailable and it was not a cancellation
                // TODO cover this in tests...
                (!state.installedAvailable && !state.installQueue.includes(name_2))) {
                uninstallQueue = reorderUninstallQueue(state.appByName, uninstallQueue.concat(__spreadArray(__spreadArray([], __read(findDependents(state.appByName, name_2).filter(function (d) {
                    return state.installed.some(function (a) { return a.name === d; });
                })), false), [
                    name_2,
                ], false)));
            }
            return __assign(__assign({}, state), { currentError: null, installQueue: installQueue, uninstallQueue: uninstallQueue });
        }
    }
};
exports.reducer = reducer;
var defaultConfig = {
    warnMemoryRatio: 0.1,
    sortApps: false
};
// calculate all size information useful for display
var distribute = function (state, config) {
    var _a = __assign(__assign({}, defaultConfig), config), warnMemoryRatio = _a.warnMemoryRatio, sortApps = _a.sortApps;
    var blockSize = getBlockSize(state);
    var totalBytes = state.deviceModel.memorySize;
    var totalBlocks = Math.floor(totalBytes / blockSize);
    var osBytes = (state.firmware && state.firmware.bytes) || 0;
    var osBlocks = Math.ceil(osBytes / blockSize);
    var appsSpaceBlocks = totalBlocks - osBlocks;
    var appsSpaceBytes = appsSpaceBlocks * blockSize;
    var totalAppsBlocks = 0;
    var apps = state.installed.map(function (app) {
        var name = app.name, blocks = app.blocks;
        totalAppsBlocks += blocks;
        var currency = (0, currencies_1.findCryptoCurrency)(function (c) { return c.managerAppName === name; });
        return {
            currency: currency,
            name: name,
            blocks: blocks,
            bytes: blocks * blockSize
        };
    });
    if (sortApps) {
        apps.sort(function (a, b) { return b.blocks - a.blocks; });
    }
    var totalAppsBytes = totalAppsBlocks * blockSize;
    var freeSpaceBlocks = appsSpaceBlocks - totalAppsBlocks;
    var freeSpaceBytes = freeSpaceBlocks * blockSize;
    var shouldWarnMemory = freeSpaceBlocks / appsSpaceBlocks < warnMemoryRatio;
    return {
        totalBlocks: totalBlocks,
        totalBytes: totalBytes,
        osBlocks: osBlocks,
        osBytes: osBytes,
        apps: apps,
        appsSpaceBlocks: appsSpaceBlocks,
        appsSpaceBytes: appsSpaceBytes,
        totalAppsBlocks: totalAppsBlocks,
        totalAppsBytes: totalAppsBytes,
        freeSpaceBlocks: freeSpaceBlocks,
        freeSpaceBytes: freeSpaceBytes,
        shouldWarnMemory: shouldWarnMemory
    };
};
exports.distribute = distribute;
function getBlockSize(state) {
    return state.deviceModel.getBlockSize(state.deviceInfo.version);
}
exports.getBlockSize = getBlockSize;
// tells if the state is "incomplete" to implement the Manager v2 feature
// this happens when some apps are unrecognized
var isIncompleteState = function (state) {
    return state.installed.some(function (a) { return !a.name; });
};
exports.isIncompleteState = isIncompleteState;
// calculate if a given state (typically a predicted one) is out of memory (meaning impossible to reach with a device)
var isOutOfMemoryState = function (state) {
    var blockSize = getBlockSize(state);
    var totalBytes = state.deviceModel.memorySize;
    var totalBlocks = Math.floor(totalBytes / blockSize);
    var osBytes = (state.firmware && state.firmware.bytes) || 0;
    var osBlocks = Math.ceil(osBytes / blockSize);
    var appsSpaceBlocks = totalBlocks - osBlocks;
    var totalAppsBlocks = state.installed.reduce(function (sum, app) { return sum + app.blocks; }, 0);
    return totalAppsBlocks > appsSpaceBlocks;
};
exports.isOutOfMemoryState = isOutOfMemoryState;
var isLiveSupportedApp = function (app) {
    var currency = app.currencyId
        ? (0, currencies_1.findCryptoCurrencyById)(app.currencyId)
        : null;
    return currency ? (0, currencies_1.isCurrencySupported)(currency) : false;
};
exports.isLiveSupportedApp = isLiveSupportedApp;
var updateAllProgress = function (state) {
    var total = state.updateAllQueue.length;
    /** each uninstall and install comes in a pair and have a weight of 0.5 in the progress */
    var current = (state.uninstallQueue.length + state.installQueue.length) / 2;
    if (total === 0 || current === 0)
        return 1;
    return Math.max(0, Math.min((total - current) / total, 1));
};
exports.updateAllProgress = updateAllProgress;
// a series of operation to perform on the device for current state
var getActionPlan = function (state) {
    return state.uninstallQueue
        .map(function (name) {
        return ({
            type: "uninstall",
            name: name
        });
    })
        .concat(state.installQueue.map(function (name) {
        return ({
            type: "install",
            name: name
        });
    }));
};
exports.getActionPlan = getActionPlan;
// get next operation to perform
var getNextAppOp = function (state) {
    if (state.uninstallQueue.length) {
        return {
            type: "uninstall",
            name: state.uninstallQueue[0]
        };
    }
    else if (state.installQueue.length) {
        return {
            type: "install",
            name: state.installQueue[0]
        };
    }
};
exports.getNextAppOp = getNextAppOp;
// resolve the State to predict when all queued ops are done
var predictOptimisticState = function (state) {
    var s = __assign(__assign({}, state), { currentProgressSubject: null });
    return (0, exports.getActionPlan)(s)
        .map(function (appOp) {
        return ({
            type: "onRunnerEvent",
            event: {
                type: "runSuccess",
                appOp: appOp
            }
        });
    })
        .reduce(exports.reducer, s);
};
exports.predictOptimisticState = predictOptimisticState;
//# sourceMappingURL=logic.js.map